export default "__VITE_ASSET__fws6AL7O__"